import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    athleteAge: '',
    skillLevel: '',
    primarySport: '',
    esaStudent: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    alert('Thank you for your interest! Coach Slater will be in touch soon.');
    // Reset form
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      athleteAge: '',
      skillLevel: '',
      primarySport: '',
      esaStudent: '',
      message: ''
    });
  };
  return <section id="contact" className="py-20 md:py-28 bg-sep-black text-white" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-16" data-id="element-32">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl uppercase mb-4" data-id="element-33">
            GET IN TOUCH WITH COACH SLATER
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-gray-400 text-lg" data-id="element-34">
            Ready to elevate your game? Fill out the form below to book your
            session.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8" data-id="element-35">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-1 space-y-8" data-id="element-36">
            <div className="bg-white/5 border border-white/10 rounded-lg p-8 h-full" data-id="element-37">
              <h3 className="font-heading font-bold text-2xl mb-8 border-b border-white/10 pb-4" data-id="element-38">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-39">
                <div className="flex items-start gap-4" data-id="element-40">
                  <div className="w-10 h-10 rounded-full bg-sep-red/20 flex items-center justify-center flex-shrink-0" data-id="element-41">
                    <Phone className="w-5 h-5 text-sep-red" data-id="element-42" />
                  </div>
                  <div data-id="element-43">
                    <p className="text-sm text-gray-400 uppercase tracking-wider font-bold mb-1" data-id="element-44">
                      Phone
                    </p>
                    <a href="tel:480-553-3411" className="text-lg hover:text-sep-red transition-colors" data-id="element-45">
                      480-553-3411
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-46">
                  <div className="w-10 h-10 rounded-full bg-sep-red/20 flex items-center justify-center flex-shrink-0" data-id="element-47">
                    <Mail className="w-5 h-5 text-sep-red" data-id="element-48" />
                  </div>
                  <div data-id="element-49">
                    <p className="text-sm text-gray-400 uppercase tracking-wider font-bold mb-1" data-id="element-50">
                      Email
                    </p>
                    <a href="mailto:info@slatereliteperformance.com" className="text-lg hover:text-sep-red transition-colors break-all" data-id="element-51">
                      info@slatereliteperformance.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-52">
                  <div className="w-10 h-10 rounded-full bg-sep-red/20 flex items-center justify-center flex-shrink-0" data-id="element-53">
                    <MapPin className="w-5 h-5 text-sep-red" data-id="element-54" />
                  </div>
                  <div data-id="element-55">
                    <p className="text-sm text-gray-400 uppercase tracking-wider font-bold mb-1" data-id="element-56">
                      Serving
                    </p>
                    <p className="text-lg" data-id="element-57">
                      Maricopa, AZ &<br data-id="element-58" />
                      East Valley, AZ
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 pt-8 border-t border-white/10" data-id="element-59">
                <p className="text-sm text-gray-400 uppercase tracking-wider font-bold mb-4" data-id="element-60">
                  Follow Us
                </p>
                <div className="flex gap-4" data-id="element-61">
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-sep-red transition-colors" data-id="element-62">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-63">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-64" />
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-sep-red transition-colors" data-id="element-65">
                    <Instagram className="w-5 h-5" data-id="element-66" />
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-sep-red transition-colors" data-id="element-67">
                    <Facebook className="w-5 h-5" data-id="element-68" />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-2" data-id="element-69">
            <form onSubmit={handleSubmit} className="bg-white/5 border border-white/10 rounded-lg p-8" data-id="element-70">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-71">
                <div data-id="element-72">
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-73">
                    First Name *
                  </label>
                  <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors" data-id="element-74" />
                </div>
                <div data-id="element-75">
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-76">
                    Last Name *
                  </label>
                  <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors" data-id="element-77" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-78">
                <div data-id="element-79">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-80">
                    Phone Number *
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors" data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-83">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors" data-id="element-84" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-85">
                <div data-id="element-86">
                  <label htmlFor="athleteAge" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-87">
                    Athlete Age
                  </label>
                  <input type="number" id="athleteAge" name="athleteAge" value={formData.athleteAge} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors" data-id="element-88" />
                </div>
                <div data-id="element-89">
                  <label htmlFor="skillLevel" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-90">
                    Skill Level
                  </label>
                  <select id="skillLevel" name="skillLevel" value={formData.skillLevel} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors appearance-none" data-id="element-91">
                    <option value="" data-id="element-92">Select Level</option>
                    <option value="beginner" data-id="element-93">Beginner</option>
                    <option value="intermediate" data-id="element-94">Intermediate</option>
                    <option value="advanced" data-id="element-95">Advanced</option>
                  </select>
                </div>
                <div data-id="element-96">
                  <label htmlFor="esaStudent" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-97">
                    ESA Student?
                  </label>
                  <select id="esaStudent" name="esaStudent" value={formData.esaStudent} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors appearance-none" data-id="element-98">
                    <option value="" data-id="element-99">Select</option>
                    <option value="yes" data-id="element-100">Yes</option>
                    <option value="no" data-id="element-101">No</option>
                  </select>
                </div>
              </div>

              <div className="mb-6" data-id="element-102">
                <label htmlFor="primarySport" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-103">
                  Primary Sport
                </label>
                <input type="text" id="primarySport" name="primarySport" value={formData.primarySport} onChange={handleChange} placeholder="e.g. Basketball, Football, Track" className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors" data-id="element-104" />
              </div>

              <div className="mb-8" data-id="element-105">
                <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-106">
                  Message / Goals
                </label>
                <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full bg-black/50 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-sep-red focus:ring-1 focus:ring-sep-red transition-colors resize-none" data-id="element-107"></textarea>
              </div>

              <button type="submit" className="w-full bg-sep-red hover:bg-sep-red-dark text-white font-bold py-4 px-8 rounded-md transition-colors uppercase tracking-wide text-lg" data-id="element-108">
                LET'S GET ELITE
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}